<template>
  <div class="content">
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item  prop="question" >
        <el-input v-model="queryParams.question" placeholder="问题内容" clearable @keyup.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
            <el-button type="primary"  icon="el-icon-plus" @click="addhelp" v-hasPermi="['help:center:helpAdd']">新增</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border>
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="question" label="问题" align="center" ></el-table-column>
      <el-table-column prop="type" label="类型" align="center" width="100px">
        <template slot-scope="{row}" >
          <el-tag v-if="row.type == '0'">常见问题</el-tag>
          <el-tag v-else-if="row.type == '1'" type="success">充值问题</el-tag>
          <el-tag v-else-if="row.type == '2'" type="info">网络问题</el-tag>
          <el-tag v-else-if="row.type == '3'" type="warning">设备问题</el-tag>
          <el-tag v-else-if="row.type == '4'" type="danger">其他问题</el-tag>
          <el-tag v-else type="warning">未知</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="answer" label="答案" align="center" width="700px"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
      <el-table-column label="操作" width="230" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain icon="el-icon-edit"  @click="updateRow(scope.row.id)" v-hasPermi="['help:center:helpEdit']">编辑</el-button>
          <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="deleteRow(scope.row.id)" v-hasPermi="['help:center:helpDel']">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="page"
      :limit.sync="pageSize"
      @pagination="initData"
    />
  </div>
</template>
<script>
import {helpList, helpDelete} from "@/api/api.js";
export default {
  data(){
    return {
      queryParams:{},
      tableData:[],
      page: 1,
      pageSize: 20,
      total: 0,
    }
  },
  computed:{},
  methods:{
    // 获取列表信息
    initData() {
      let params = {
        model:{
          ...this.queryParams,
        },
        page: this.page,
        pageSize: this.pageSize,
      };
      helpList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    // 搜索
    search(){
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery(){
      this.resetForm("queryForm");
      this.search()
    },
    //新增
    addhelp(){
      this.$router.push('/helpCenter/help/add')
    },
    //编辑
    updateRow(id){
      this.$router.push(`/helpCenter/help/edit/`+id);
    },
    deleteRow(id){
      let params = {
        id: id,
      };
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        helpDelete(params).then(res => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.initData();
          }else{
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
    },
  },
  created(){
    this.initData();
  },
  mounted(){

  }
}
</script>

